import { useMemo, useReducer } from 'react';
import { UPDATE_CODE_FULLSCREEN_MODE_ON, UPDATE_FORM_TAB, UPDATE_THEME, UPDATE_VIEW_MODE, initialState, reducer, } from './reducer';
export function useSettingsState() {
    const [{ formTab, viewMode, theme, codeFullscreeModeOn }, dispatch] = useReducer(reducer, initialState);
    return useMemo(() => {
        return {
            formTab,
            viewMode,
            theme,
            codeFullscreeModeOn,
            onFormTabUpdate: (newFormTab) => dispatch({ type: UPDATE_FORM_TAB, payload: newFormTab }),
            onViewModeUpdate: (newViewMode) => dispatch({ type: UPDATE_VIEW_MODE, payload: newViewMode }),
            onThemeUpdate: (newTheme) => dispatch({ type: UPDATE_THEME, payload: newTheme }),
            onCodeFullscreeModeOnUpdate: (newCodeFullscreeModeOn) => dispatch({ type: UPDATE_CODE_FULLSCREEN_MODE_ON, payload: newCodeFullscreeModeOn }),
        };
    }, [formTab, viewMode, theme, codeFullscreeModeOn]);
}
